// extracted by mini-css-extract-plugin
export default {"root":"menu_root__dAZVj","logo":"menu_logo__SvAbc","logoText":"menu_logoText__1IRPu","title":"menu_title__pzug9","hr":"menu_hr__PYwdj","list":"menu_list__qeq2L"};